"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    date: _propTypes.default.string.isRequired,
    formattedDate: _propTypes.default.string.isRequired,
    price: _propTypes.default.string,
    active: _propTypes.default.bool,
    least: _propTypes.default.bool,
    currency: _propTypes.default.string,
    theme: _propTypes.default.string,
    showShimmer: _propTypes.default.bool,
    handleClick: _propTypes.default.func,
    customProperties: _propTypes.default.object,
    isMobile: _propTypes.default.bool,
    noFlights: _propTypes.default.bool,
    soldOut: _propTypes.default.bool,
    translation: _propTypes.default.object,
    showView: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    active: false,
    least: false,
    showShimmer: false,
    isMobile: false,
    noFlights: false,
    soldOut: false,
    translation: {}
  }
};
exports.default = _default;